/**
 * Insert/replace item in list, based on `item.id`
 *
 * @param arr - list
 * @param item - item to insert
 */
export const addOrReplaceItem = <T extends { id: number }>(
  arr: T[],
  item: T
) => {
  if (!arr) return [item];

  const nextFiles = [...arr];
  const index = nextFiles.findIndex((v) => v.id === item.id);

  if (index > -1) {
    // replace file
    nextFiles.splice(index, 1, item);
  } else {
    // add file
    nextFiles.push(item);
  }

  return nextFiles;
};
